import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

const PatientPrescriptions = ({ prescriptions }) => (
  <Paper sx={{ padding: 2 }}>
    <Typography variant='h6'>Prescriptions</Typography>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Date</TableCell>
          <TableCell>Medication</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {prescriptions.map((prescription) => (
          <TableRow key={prescription.id}>
            <TableCell>{prescription.date}</TableCell>
            <TableCell>{prescription.medication}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);

export default PatientPrescriptions;
